<!-- BaseCheckbox.vue (admin) -->
<template tag="관리자 체크박스 컴포넌트">
  <!-- 전체 선택 체크박스 -->
  <v-checkbox
    v-if="isAll"
    :label="label || '전체 선택'"
    class="mr-4"
    :model-value="isAllChecked"
    :readonly="readonly || disabled"
    @update:model-value="handleAllChange"
  />

  <!-- 개별 체크박스 -->
  <v-checkbox
    v-else
    v-for="option in options"
    :key="option.value"
    v-model="model"
    :label="option.label"
    :value="option.value"
    class="mr-4"
    :readonly="readonly || disabled"
  />
</template>
<script setup lang="ts">
import { computed, type PropType } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string[] | null>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  label: { type: String, default: "" },
  disabled: Boolean,
  readonly: Boolean,
  isAll: Boolean, // 전체선택 체크박스 여부
  options: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => [],
  }, // admin 모드 옵션
});

/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
/** 전체 선택 체크박스 체크 여부 */
const isAllChecked = computed(() => {
  if (!Array.isArray(model.value) || props.options.length === 0) return false;
  return model.value.length === props.options.length;
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 전체 선택 체크박스 변경 처리 */
const handleAllChange = (checked: boolean | null) => {
  if (checked === true) {
    model.value = props.options.map((o) => o.value);
  } else {
    model.value = [];
  }
};
</script>
